import { createColumnHelper } from '@tanstack/react-table';
import { Trash2 } from 'lucide-react';

import { Button } from '@@/buttons';
import { Badge } from '@@/Badge';

import { SilencedAlertRow } from './types';

export const columnHelper = createColumnHelper<SilencedAlertRow>();

export function createColumns(onDelete: (silenceId: string) => void) {
  return [
    columnHelper.accessor('alertRule', {
      header: 'Alert Rule',
    }),
    columnHelper.accessor('comment', {
      header: 'Comment',
    }),
    columnHelper.accessor('createdBy', {
      header: 'Created By',
    }),
    columnHelper.accessor('startsAt', {
      header: 'Starts At',
    }),
    columnHelper.accessor('endsAt', {
      header: 'Ends At',
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      cell: ({ getValue }) => {
        const status = getValue();
        let badgeType: 'success' | 'warn' | 'muted' | 'danger' = 'muted';

        if (status === 'active') {
          badgeType = 'success';
        } else if (status === 'pending') {
          badgeType = 'warn';
        } else if (status === 'expired') {
          badgeType = 'muted';
        } else {
          badgeType = 'danger';
        }

        return <Badge type={badgeType}>{status}</Badge>;
      },
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Actions',
      cell: ({ row }) => {
        const silence = row.original;
        return (
          <Button
            color="dangerlight"
            size="small"
            onClick={() => onDelete(silence.id)}
            disabled={!silence.canDelete}
            title={
              silence.canDelete
                ? 'Delete silence'
                : 'Cannot delete expired/revoked silence'
            }
            data-cy={`delete-silence-${silence.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        );
      },
    }),
  ];
}
